<div class="projects-page">
  <header class="page-hero">
    <h1>Trabajo real, explicado sin adornos.</h1>
    <p class="hero-lead">
      Un caso real, terminado y en funcionamiento que puedes visitar y comprobar.
    </p>
  </header>

  <section aria-labelledby="selected-projects-title">
    <div class="section-heading">
      <h2 id="selected-projects-title">Skepsis Ink</h2>
      <p>
        Web profesional para presentar el trabajo y facilitar el contacto de una tatuadora en
        Segovia.
      </p>
    </div>

    <article class="project-card">
      <a
        class="project-preview"
        href="https://skepsisink.com"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Visitar Skepsis Ink; se abre en una pestaña nueva"
      >
        <img
          src="/images/projects/skepsisink-home.webp"
          srcset="
            /images/projects/responsive/skepsisink-home.webp  720w,
            /images/projects/skepsisink-home.webp            1440w
          "
          sizes="(max-width: 48rem) calc(100vw - 2.5rem), 76rem"
          width="1440"
          height="1000"
          fetchpriority="high"
          decoding="async"
          alt="Página de inicio de Skepsis Ink con presentación y fotografía de un tatuaje floral"
        />
      </a>

      <div class="project-details">
        <div class="project-heading">
          <div>
            <p class="project-type">Proyecto real · Desarrollo web</p>
            <h3>Skepsis Ink</h3>
          </div>
          <a href="https://skepsisink.com" target="_blank" rel="noopener noreferrer">
            Visitar skepsisink.com
            <svg
              class="external-link-icon"
              viewBox="0 0 20 20"
              aria-hidden="true"
              focusable="false"
            >
              <path d="M7 5h8v8M15 5 5 15" />
            </svg>
          </a>
        </div>

        <p class="project-summary">
          Una presencia digital centrada en el trabajo de Skepsis, tatuadora en Segovia
          especializada en línea fina, puntillismo y diseños personalizados.
        </p>

        <div class="project-proof" aria-labelledby="project-proof-title">
          <h4 id="project-proof-title">Qué se puede comprobar</h4>
          <ul>
            <li>El proyecto está publicado y funciona en su dominio real.</li>
            <li>El portfolio ocupa el centro de la experiencia y muestra el trabajo sin rodeos.</li>
            <li>La presentación, el proceso y el contacto siguen un recorrido claro.</li>
          </ul>
        </div>

        <dl class="project-scope">
          <div>
            <dt>Punto de partida</dt>
            <dd>Presentar su propuesta, mostrar trabajos y ofrecer vías claras de contacto.</dd>
          </div>
          <div>
            <dt>Decisión principal</dt>
            <dd>Dar prioridad visual al portfolio para que el trabajo explique la propuesta.</dd>
          </div>
          <div>
            <dt>Entrega visible</dt>
            <dd>Portfolio, presentación, forma de trabajo, preguntas frecuentes y contacto.</dd>
          </div>
          <div>
            <dt>Estado</dt>
            <dd>Proyecto desarrollado por ATSIestudio, terminado, publicado y funcional.</dd>
          </div>
        </dl>
      </div>
    </article>
  </section>

  <section class="projects-cta" aria-labelledby="projects-cta-title">
    <h2 id="projects-cta-title">Hablemos de lo que necesita tu empresa.</h2>
    <p>Cuéntanos el punto de partida y el objetivo que quieres conseguir.</p>
    <a class="button button-primary" routerLink="/contacto">Empezar una conversación</a>
  </section>
</div>
